package modysy.menu

import modysy.InputHandler
import modysy.datastructures.Vector2
import modysy.gamestate.{GameState, GameStateManager}
import modysy.view.Color
import org.scalajs.dom

class LoseScreenMenu(
    stateManager: GameStateManager,
    inputs: InputHandler,
    width: Int,
    height: Int
) extends AbstractMenu(inputs, width, height) {

  private val buttonDistance = 0.095f
  private val buttonStart = 0.65f

  {
    val retryButton = new TextButton(
      width * 0.5,
      buttonStart * height,
      "Try again"
    )
    retryButton.fontSize = Math.round(height / 12)
    retryButton.colorSelected = Color.Lose_Blue

    retryButton.action = () => {
      stateManager.retryLevel()
    }

    val exitButton = new TextButton(
      width * 0.5,
      (buttonStart + buttonDistance) * height,
      "Main Menu"
    )
    exitButton.fontSize = Math.round(height / 12)
    exitButton.colorSelected = Color.Lose_Blue

    exitButton.action = () => {
      stateManager.exitGame()
    }

    buttons = retryButton :: exitButton :: buttons
    buttons.foreach(button => {
      val tmp = button.isEnabled
      button.isEnabled = () => {
        tmp() && (stateManager.gameState == GameState.endscreenLose)
      }
    })
    buttons.foreach(button => {
      button.enableTouch(inputs)
    })
  }

  override def render(ctx: dom.CanvasRenderingContext2D): Unit = {

    //ctx.fillStyle = Color.Black
    ctx.fillStyle = Color.rgba(255, 255, 255, 0.3)
    ctx.fillRect(0, 0, width, height)

    ctx.textAlign = "center"

    ctx.font = height / 4 + "px Arial"
    ctx.fillStyle = Color.Lose_Blue
    ctx.textBaseline = "alphabetic"
    ctx.fillText("Level failed!", width / 2, height * 0.325, Integer.MAX_VALUE)

    super.render(ctx)
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/LoseScreenMenu.scala